// Full-screen black photo viewer shared by Supplier and Group galleries: swipe, previous/next, thumbnails, close
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { imageSrc } from './SupplierImages';

export default function PhotoViewer({ photos, index, onIndex, onClose }) {
  const { t } = useTranslation();
  const touchX = useRef(null);
  const step = (d) => onIndex((index + d + photos.length) % photos.length);

  return (
    <div
      role="dialog"
      aria-label={t('photos.label')}
      className="fixed inset-0 z-[70] bg-black/85 flex flex-col items-center justify-center p-4"
      onTouchStart={(e) => { touchX.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => {
        const dx = e.changedTouches[0].clientX - (touchX.current ?? 0);
        touchX.current = null;
        if (Math.abs(dx) > 40 && photos.length > 1) step(dx < 0 ? 1 : -1);
      }}
    >
      <button type="button" onClick={onClose} aria-label={t('photos.close')} className="absolute top-3 right-3 text-white text-3xl px-3">×</button>
      <div className="flex items-center gap-2 w-full justify-center">
        <button type="button" onClick={() => step(-1)} disabled={photos.length < 2} aria-label={t('photos.previous')} className="text-white text-4xl px-2 disabled:opacity-40">‹</button>
        <img src={imageSrc(photos[index])} alt="" className="max-h-[70vh] max-w-full object-contain rounded" />
        <button type="button" onClick={() => step(1)} disabled={photos.length < 2} aria-label={t('photos.next')} className="text-white text-4xl px-2 disabled:opacity-40">›</button>
      </div>
      <div className="mt-3 flex gap-2 overflow-x-auto max-w-full">
        {photos.map((key, i) => (
          <button key={key} type="button" onClick={() => onIndex(i)} aria-label={`Photo ${i + 1}`} className={`shrink-0 rounded border-2 ${i === index ? 'border-green-500' : 'border-transparent'}`}>
            <img src={imageSrc(key)} alt="" className="h-12 w-12 object-cover rounded" />
          </button>
        ))}
      </div>
      <div className="mt-2 text-white text-sm">{index + 1} / {photos.length}</div>
    </div>
  );
}
